/* eslint-disable no-new */
/* eslint-disable no-inner-declarations */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState, useEffect, useCallback, SetStateAction } from 'react';
import jwt from 'jwt-decode';

import localforage from 'localforage';
import { v4 as uuidv4 } from 'uuid';
import {
  makeStyles,
  IconButton,
  Popover,
  Checkbox,
  withStyles,
  CheckboxProps,
  FormControlLabel,
  Tooltip,
} from '@material-ui/core';
import {
  Clear,
  Computer,
  Equalizer,
  List,
  People,
  Phone,
  QuestionAnswer,
  Security,
  SettingsApplications,
  SettingsOutlined,
} from '@material-ui/icons';

import { brown, green, grey, pink, blue } from '@material-ui/core/colors';
import './styles/CX.css';
import { Map as ImmutableMap } from 'immutable';

import hash from 'object-hash';
import Websocket from './Websocket';
import Hud from './Hud';
import Profile from './Profile';
import Disposition from './Disposition';
import Portal, { VMOnly } from './Portal';
import Settings from './Settings';
import Queues, {
  CallEvent,
  UserPresenceEvent,
  QueuePresenceEvent,
  Historical,
  Summary,
  Delta,
  QueueCallState,
  CallbackState,
  UserState,
  CallUser,
} from './QueueLeaderboard';
import Chat, { Message, CustomMessageContent } from './Chat';
import SleepDetector from './SleepDetector';
import './styles/Dialer.css';
import './styles/C2G.css';
import C2GReport, { UserState as ReportUserState } from './C2GReport';
import CxDashboard, { CXAgent, CxCall, CXExtension } from './CxDashboard';
import CxAgent from './CxAgent';
import DialerBox from './NEW/Dialer';
import Navbar from './NEW/Navbar';
import NewDisposition, { DispositionEvent } from './NEW/NewDisposition';
import './NEW/Disposition.css';
import IvrHud, { HistoricalIvr, IvrState } from './IvrSummary/IvrHud';
import Sai from './SAI/Sai';
import SaiDraggableWrapper from './SAI/DraggableWrapper';
import LiveDashboard from './LiveDashboard/LiveDashboard';
import { MetricObject } from './QueueWidgetContainer';
import PortalFrame, { TabComponent } from './AdminPortal/PortalFrame';
import Codes from './AdminPortal/Codes';
import Presences from './AdminPortal/Presences';
import Globals from './AdminPortal/Globals';
import Users from './AdminPortal/Users';
import Vip from './AdminPortal/VIP';
import QueuesPortal from './AdminPortal/QueuesPortal';

localforage.config({
  name: 'localforage',
  storeName: 'keyvaluepairs-v3',
  version: 1.0,
});

class PresenceEvent extends MessageEvent<{
  type: string;
  userStatus: string;
  dndStatus: string;
  message: string;
  call?: {
    from?: string;
    to?: string;
    direction?: string;
  };
}> {
  constructor(data: {
    type: string;
    userStatus: string;
    dndStatus: string;
    message: string;
    call?: {
      from?: string;
      to?: string;
      direction?: string;
    };
  }) {
    super('presence-event', { data });
  }
}

declare global {
  interface Window {
    googleTranslateElementInit: () => void;
  }
}

export interface IvrLists {
  extensionNumber: string;
  id: string;
  name: string;
  ttl: number;
  disabled?: boolean;
}

const useStyles = makeStyles((theme) => ({
  button: {
    backgroundColor: '#0684BD',
    '&:hover, &.Mui-focusVisible': { backgroundColor: '#2F99C8' },
  },
}));

const url = new URL(window.location.toString());
const sessionId = uuidv4();

// const cxToken = url.searchParams.get("cx-token");

const region = 'us-east-1';
const identityPoolId = 'us-east-1:78a6894c-2ea5-4717-8bc3-20687b670c65';
const userPoolId = 'us-east-1_wVEkcKvA0';

interface ExAgent {
  custom: string;
  department?: string;
  display?: string;
  email?: string;
  emergency?: boolean;
  extensionNumber?: string;
  firstName: string;
  glipStatus?: string;
  id: string;
  jobTitle?: string;
  lastDndStatus?: string;
  lastMessage?: string;
  lastName: string;
  lastPresenceStatus?: string;
  messageTimestamp?: string;
  site?: {
    name?: string;
  };
  status?: string;
  type?: string;
  uri?: string;
}
function App({
  idToken,
  organizationId,
  rcId,
  email,
  mode,
  setMode,
  clientId,
  redirectUri,
  rcAccessToken,
  flags,
  isAdmin,
  superAdmin,
}: {
  flags: { [key: string]: boolean };
  idToken: string;
  organizationId: string;
  rcId: string;
  email: string;
  mode: string;
  setMode: React.Dispatch<SetStateAction<string>>;
  clientId: string;
  redirectUri: string;
  rcAccessToken: string;
  isAdmin: boolean;
  superAdmin: boolean;
}) {
  const [userLeaderboardApi, setUserLeaderboardApi] = useState<any | undefined>();

  // Stickies
  const [showAvailable, setShowAvailable] = useState<boolean>(true);
  const [showBusy, setShowBusy] = useState<boolean>(true);
  const [showDnd, setShowDnd] = useState<boolean>(true);
  const [showInvisible, setShowInvisible] = useState<boolean>(true);
  const [page, setPage] = useState<string>('hud');
  const [sidebar, setSidebar] = useState(false);
  const [tab, setTab] = useState<string>('users');

  const [showLeaderboards, setShowLeaderboards] = useState<boolean | undefined>(true);

  // Flags
  const [doubleWidgets] = useState<boolean>(flags.doubleWidgets);
  const [newDisposition, setNewDisposition] = useState<boolean>(flags.newDisposition);
  const [ivrSummary, setIvrSummary] = useState<boolean>(flags.ivrSummary);
  const [hasAccountCodes, setHasAccountCodes] = useState<boolean>(flags.accountCodes);
  const [callHandling, setCallHandling] = useState<boolean>(true);
  const [noEncoding, setNoEncoding] = useState<boolean>(flags.noEncoding);
  const [hasDispositionCodes, setHasDispositionCodes] = useState<boolean>(flags.dispositionCodes);
  const [hasForcedAccountCodes, setHasForcedAccountCodes] = useState<boolean>(flags.forcedAccountCodes);
  const [hasPresenceTimer, setHasPresenceTimer] = useState<boolean>(flags.presenceTimers);
  const [hasTimerNoSwitch, setHasTimerNoSwitch] = useState<boolean>(flags.timerNoSwitch || true);
  const [hasInvisibleCallControl, setHasInvisibleCallControl] = useState<boolean>(flags.invisibleCallControl);
  const [hasDispositionTab, setHasDispositionTab] = useState<boolean>(flags.dispositionTab);
  const [newRoles, setNewRoles] = useState<boolean>(flags.newRoles); //  roles feature flag
  const [hasBrowserPhone, setBrowserPhone] = useState<boolean>(flags.browserPhone);
  const [dialer, setDialer] = useState(true);
  const [sai, setSai] = useState(false);
  const [reporting, setReporting] = useState<boolean>(false);
  const [queueCallPickUp, setQueueCallPickUp] = useState<boolean>(flags.cherryPick);
  const [showCherryPick, setShowCherryPick] = useState<boolean | undefined>(flags.cherryPick);
  const [aiSummary, setAiSummary] = useState<boolean>(flags.aiSummary); // ai feature flag
  const [showHandRaise, setShowHandRaise] = useState<boolean>(flags.handRaise);
  const [showVip, setShowVip] = useState<boolean>(flags.vip);
  const [showCallback, setShowCallback] = useState<boolean>(flags.callback);
  const [legacyUI, setLegacyUI] = useState<boolean>(organizationId !== '3154756020' && organizationId !== '63002203008');
  const [queueCompactView, setQueueCompactView] = useState(false);
  const [mobileNav, setMobileNav] = useState(false);
  const [forceAvailable, setForceAvailable] = useState<boolean>(false);
  const [hasC2G, setHasC2G] = useState<boolean>(flags.cradleToGrave);
  const [supervise, setSupervise] = useState<boolean>(flags.supervise);
  const [enableIvr, setEnableIvr] = useState(false);
  const [agentLeaderboard, setAgentLeaderboard] = useState<boolean>(flags.agentLeaderboard);
  const [hasUserHeadlines, setHasUserHeadlines] = useState<boolean>(flags.headlines);
  const [leaderboards, setLeaderboards] = useState<boolean>(flags.leaderboards);
  const [presenceQueue, setPresenceQueue] = useState<boolean | undefined>(flags.presenceQueue);
  const [queueLeaderboards, setQueueLeaderboards] = useState<boolean | undefined>(flags.queueLeaderboards);
  const [showQueueLeaderboards, setShowQueueLeaderboards] = useState<boolean | undefined>(flags.queueDisplay);

  // Settings
  const [showCXLeaderboards, setShowCXLeaderboards] = useState<boolean | undefined>(true);

  // Data structures
  const [codeMap, setCodeMap] = useState<ImmutableMap<string, DispositionEvent>>(ImmutableMap());
  const [smsData, setSmsData] = useState<Array<any>>([]);
  const [profileId, setProfileId] = useState<string | undefined>();
  const [historicalQueues, setHistoricalQueues] = useState<ImmutableMap<string, any>>(ImmutableMap());
  const [tables, setTables] = useState<Array<any>>([]);
  const [historicalUsers, setHistoricalUsers] = useState<ImmutableMap<string, any>>(ImmutableMap());
  const [historicalIvr, setHistoricalIvr] = useState<ImmutableMap<string, HistoricalIvr>>(ImmutableMap());
  const [vipList, setViplist] = useState<any>([]);
  const [elapsedTime, setElapsedTime] = useState<string>('full');
  const [changeTab, setChangeTab] = useState<string>(localStorage.getItem('changeTab') || 'Disabled');
  const [lastCode, setLastCode] = useState<string | undefined>();
  const [codes, setCodes] = useState<Array<any> | undefined>();
  const [rules, setRules] = useState<Array<any> | undefined>();
  const [timer, setTimer] = useState<{ duration: string; id: string; endTimestamp?: string } | undefined>();
  const [lateTimer, setLateTimer] = useState<{ duration: string; id: string; startTimestamp?: string } | undefined>();
  const [dispositionCodes, setDispositionCodes] = useState<Array<any> | undefined>();
  const [accountCodes, setAccountCodes] = useState<Array<any> | undefined>();
  const [forcedCodes, setForcedCodes] = useState<Array<any> | undefined>();

  const [forwardAddress, setForwardAddress] = useState<string | undefined>();
  const [cxAddress, setCxAddress] = useState<string | undefined>();
  const [websocketAddress, setWebsocketAddress] = useState<string | undefined>();
  const [local, setLocal] = useState<any>(localStorage);
  const [offset, setOffset] = useState<number>(0);
  const [tokenExists, setTokenExists] = useState<boolean>(isAdmin);
  const [historicals, setHistoricals] = useState<Array<Historical>>([]);
  const [callbacks, setCallbacks] = useState<Array<CallbackState> | undefined>();
  const [callEvents, setCallEvents] = useState<Array<CallEvent>>([]);
  const [presenceEvents, setPresenceEvents] = useState<Array<UserPresenceEvent>>([]);
  const [queuePresenceEvents, setQueuePresenceEvents] = useState<Array<QueuePresenceEvent>>([]);
  const [summaries, setSummaries] = useState<Array<Summary>>([]);
  const [excluded, setExcluded] = useState<Set<string> | undefined>(); // ie Queues
  const [excludedUsers, setExcludedUsers] = useState<Set<string> | undefined>();

  const [excludedIvrs, setExcludedIvrs] = useState<Set<string>>(new Set()); // IVRs
  const [excludedAirs, setExcludedAirs] = useState<Set<string>>(new Set()); // AIRs

  const [leaderboardUrl, setLeaderboardUrl] = useState<string | undefined>();
  const [chatAnchor, setChatAnchor] = useState<HTMLButtonElement | null>(null);
  const [acw, setAcw] = useState<Map<string, { duration: string; label: string }>>(new Map());
  const [leaderboardDeltas, setLeaderboardDeltas] = useState<Array<Delta>>([]);
  const [queueCallStates, setQueueCallStates] = useState<Array<QueueCallState>>([]);
  const [callbackStates, setCallbackStates] = useState<Array<CallbackState>>([]);
  const [userStates, setUserStates] = useState<ImmutableMap<string, UserState>>(ImmutableMap());
  const [ivrStates, setIvrStates] = useState<Array<IvrState>>([]);
  const [ivrDeltas, setIvrDeltas] = useState<Array<Delta>>([]);
  const [deviceId, setDeviceId] = useState<string | undefined>();
  const [spoiledCherryPickCalls, setSpoiledCherryPickCalls] = useState<Set<string>>(new Set());
  const [insightFilters, setInsightFilters] = useState<Map<string, Set<string>>>(new Map());
  const classes = useStyles();
  const [markedAsCalledBack, setMarkedAsCalledBack] = useState<Array<any>>([]);
  const [deletedVMs, setDeletedVoiceMails] = useState<Set<string>>(new Set());
  const [tooltipData, setTooltipData] = useState<CallEvent[] | undefined>();
  const [tooltipCounter, setTooltipCounter] = useState<number>(0);
  const [open, setOpen] = useState<boolean>(false); // boolean for mini-dialer
  const [socket, setSocket] = useState<any>();
  const [ivrLists, setIvrLists] = useState<Array<IvrLists>>([]);
  const [vmOnlyExtensions, setVmOnlyExtensions] = useState<Array<VMOnly>>([]);
  const [cxAgents, setCxAgents] = useState<Array<CXAgent> | undefined>();
  const [cxMessages, setCxMessages] = useState<Array<Array<CXExtension>>>([]);
  const [apiUrl, setApiUrl] = useState<string | undefined>();
  const [activeFilterRef, setActiveFilterRef] = useState<{
    [colId: string]: any;
  }>({});
  const [fullscreen, setFullscreen] = useState<string | undefined>(undefined);
  const [activeCall, setActiveCall] = useState({
    data: undefined,
    status: undefined,
  });
  const [cxStateFilters, setCxStateFilters] = useState<{
    available?: boolean;
    engaged?: boolean;
    breakAfterCall?: boolean;
    transition?: boolean;
    pendingDisposition?: boolean;
    onbreak?: boolean;
    away?: boolean;
    lunch: boolean;
    training?: boolean;
    working?: boolean;
    rnaState?: boolean;
    offline?: boolean;
    engagedController?: boolean;
    offlineController?: boolean;
    unknown?: boolean;
  }>({
    available: true,
    engaged: true,
    breakAfterCall: true,
    transition: true,
    pendingDisposition: true,
    onbreak: true,
    away: true,
    lunch: true,
    training: true,
    working: true,
    rnaState: true,
    offline: true,
    engagedController: true,
    offlineController: true,
    unknown: true,
  });
  const [newCallback, setNewCallback] = useState(false);
  const [myCalls, setMyCalls] = useState<Map<string, CallUser> | undefined>();
  const [cxCallLog, setCxCallLog] = useState<CxCall[] | undefined>(undefined);
  const [liveCalls, setLiveCalls] = useState<Map<string, CallUser[]> | undefined>();
  const [dialerMessage, setDialerMessage] = useState<string | number | undefined>(undefined);
  const [myEvents, setMyEvents] = useState<CallEvent[]>([]);
  const [meHistorical, setMeHistorical] = useState<ExAgent | undefined>(undefined);
  const [agentData, setHistoricalAgents] = useState<any[]>([]);
  const [cxEnabled, setCxEnabled] = useState<boolean | undefined>(flags.ringCX);
  // toggle between both CX and EX dialer states.
  const [selectedDialer, setSelectedDialer] = useState('ex');
  const [liveQueueMetrics, setLiveQueueMetrics] = useState<Map<string, MetricObject>>(new Map());
  const [tabCounts, setTabCounts] = useState({
    voicemail: 0,
    callback: 0,
    abandoned: 0,
  });
  const [realTimeUserStates, setRealTimeUserStates] = useState<Array<ReportUserState>>([]);

  const dialerReference = React.useRef<any>(null);
  const resetDialerPosition = useCallback(() => {
    dialerReference.current?.resetDialerPosition();
  }, []);

  useEffect(() => {
    if (historicalUsers && historicalUsers.size && rcId) {
      const me = historicalUsers.get(rcId);
      if (
        me &&
        (meHistorical === undefined || hash(me.lastPresenceStatus) !== hash(meHistorical?.lastPresenceStatus || {}))
      ) {
        setMeHistorical({ ...me });
      }
    }
  }, [historicalUsers, rcId]);

  useEffect(() => {
    if ((window as any).chrome && meHistorical !== undefined) {
      if ((window as any).chrome && (window as any).chrome.webview) {
        (window as any).chrome.webview.postMessage({
          rec: {
            presenceStatus: meHistorical.lastPresenceStatus || '',
            event: 'PRESENCE',
          },
        });
      } else {
        (window as any).postMessage({
          rec: {
            presenceStatus: meHistorical.lastPresenceStatus || '',
            event: 'PRESENCE',
          },
        });
      }
    }
  }, [meHistorical]);

  // useEffect(() => {
  //   const dialerInStorage = localStorage.getItem("sa-ex-dialer");
  //   if (dialerInStorage) {
  //     setDialer(JSON.parse(dialerInStorage));
  //   }
  //   if (!dialerInStorage) {
  //     localStorage.setItem("sa-ex-dialer", JSON.stringify(false));
  //     setDialer(false);
  //   }
  // }, []);

  useEffect(() => {
    const theme = localStorage.getItem('theme') || 'light';
    setMode(theme);
    const dialerRef = document.querySelector('#ex-dialer') as HTMLIFrameElement;
    if (dialerRef && dialerRef.contentWindow) {
      dialerRef.contentWindow!.postMessage(
        {
          type: 'rc-adapter-theme-notify',
          theme: theme === 'light' ? 'light' : 'dark',
        },
        '*',
      );
    }
    localStorage.setItem('theme', theme);
  }, []);

  useEffect(() => {
    if (socket === undefined) {
      return;
    }
    if (rcId === undefined) {
      return;
    }
    if (timer?.endTimestamp !== undefined) {
      return;
    }

    if (timer?.duration === undefined) {
      if (socket !== undefined) {
        socket.emit('cancel-acw');
      }
    } else if (timer.duration !== '0') {
      socket.emit(
        'acw',
        JSON.stringify({
          duration: parseInt(timer.duration, 10).toString(),
          id: rcId,
        }),
      );
    }
  }, [timer, socket, rcId]);

  // old tooltip data
  useEffect(() => {
    const timestamp = localStorage.getItem('timestamp');
    if (!timestamp) {
      const now = new Date();
      localStorage.setItem('timestamp', now.toISOString());
    }
    const timestampUnix = timestamp ? Math.floor(new Date(timestamp).getTime() / 1000) : undefined;
    const sumData = summaries && summaries.length > 0 ? summaries[0].myEvents : undefined;

    if (sumData === undefined) {
      return;
    }
    const recentCallEvents = sumData.filter((event: any) => {
      const eventTimestamp = Math.floor(new Date(event?.timestamp).getTime() / 1000);
      return timestampUnix === null || eventTimestamp > timestampUnix!;
    });
    const filteredCallEvents = recentCallEvents.filter((event: any) => {
      const parties = event?.body?.parties || [];
      return parties.some((party: any) => party.user.toString() === rcId?.toString());
    });
    setTooltipData((prevData: any) => {
      if (prevData === undefined) {
        return filteredCallEvents;
      }
      if (callEvents && filteredCallEvents.length > 0) {
        return [...prevData, ...filteredCallEvents, callEvents[0]];
      }
      return prevData;
    });
  }, [callEvents, rcId, summaries]);

  useEffect(() => {
    const matching = callEvents?.some((event: any) => {
      const parties = event?.body?.parties || [];
      return parties.some((party: any) => party?.user?.toString() === rcId?.toString());
    });
    if (matching) {
      if (tooltipData === undefined || !Array.isArray(tooltipData)) {
        setTooltipData([callEvents[0]]);
      } else if (tooltipData && callEvents !== undefined) {
        setTooltipData((prev: any) => [...prev, callEvents[0]]);
      }
    }
  }, [callEvents]);

  useEffect(() => {
    const builtEvents = new Map();
    if (tooltipData && Array.isArray(tooltipData)) {
      tooltipData.forEach((item: any) => {
        // eslint-disable-next-line no-shadow
        const { sessionId } = item.body;
        if (!builtEvents?.has(sessionId)) {
          builtEvents?.set(sessionId, []);
        }
        builtEvents?.get(sessionId).push(item);
      });
    }
    let limit = builtEvents?.size || 0;
    if (limit >= 99) {
      limit = 99;
    }
    setTooltipCounter(limit);
  }, [tooltipData]);

  // new tooltip for myCalls
  useEffect(() => {
    if (myCalls) {
      let lastTimestamp: string | number | null = localStorage.getItem('stage-2-timestamp');
      if (!lastTimestamp) {
        lastTimestamp = JSON.stringify(new Date(Date.now()).toISOString());
        localStorage.setItem('stage-2-timestamp', lastTimestamp);
      }
      try {
        lastTimestamp = JSON.parse(lastTimestamp);
      } catch (err) {
        console.warn(err);
      }
      let callCount = 0;
      const keysArray = Array.from(myCalls.keys());
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < keysArray.length; i++) {
        if (new Date(myCalls.get(keysArray[i])!.index.split('#')[0]).getTime() > new Date(lastTimestamp!).getTime()) {
          callCount += 1;
        }
      }
      setTooltipCounter(callCount);
    }
  }, [myCalls]);

  // hard reset for v1
  useEffect(() => {
    const ResetCounter = () => {
      const now = new Date();
      localStorage.setItem('timestamp', now.toISOString());
      setTooltipCounter(0);
      setTooltipData([]);
    };
    if (page === 'disposition') {
      ResetCounter();
    }
  }, [page, callEvents, dispositionCodes, accountCodes]);

  // hard reset for v2
  useEffect(() => {
    const ResetCounter = () => {
      localStorage.setItem('stage-2-timestamp', JSON.stringify(new Date(Date.now()).toISOString()));
      setTooltipCounter(0);
    };
    if (page === 'disposition') {
      ResetCounter();
    }
  }, [page, myCalls]);

  // send this counter up.
  useEffect(() => {
    if (origin !== undefined) {
      window.parent.postMessage(
        JSON.stringify({
          event: 'notificationCount',
          message: tooltipCounter > 99 ? '99+' : tooltipCounter,
        }),
        origin,
      );
    }
  }, [tooltipCounter, origin]);

  useEffect(() => {
    if (forwardAddress !== undefined && idToken !== null && !newCallback) {
      (async () => {
        const startTime = new Date();
        startTime.setHours(0, 0, 0, 0);

        const res = await fetch(
          forwardAddress.replace('/shadow-agent', `/callback?startTime=${startTime.toISOString()}&queue=true`),
          {
            method: 'get',
            headers: {
              authorization: idToken,
              'Content-Type': 'application/json',
            },
          },
        );
        const data = await res.json();
        if (data.calls) {
          setCallbacks(data.calls);
        }
      })();
    }
  }, [forwardAddress, idToken]);

  useEffect(() => {
    if (forwardAddress !== undefined && idToken !== null && !newCallback) {
      (async () => {
        const startTime = new Date();
        startTime.setHours(0, 0, 0, 0);

        const res = await fetch(
          forwardAddress.replace('/shadow-agent', `/marked-as-called?startTime=${startTime.toISOString()}`),
          {
            method: 'get',
            headers: {
              authorization: idToken,
              'Content-Type': 'application/json',
            },
          },
        );
        const data = await res.json();
        if (data.calls) {
          setMarkedAsCalledBack(data.calls);
        }
      })();
    }
  }, [forwardAddress, idToken]);

  useEffect(() => {
    if (idToken === undefined || idToken === null) {
      return;
    }

    if (forwardAddress === undefined) {
      return;
    }

    if (!aiSummary) {
      return;
    }

    (async () => {
      const data = await fetch(forwardAddress.replace('/shadow-agent', '/insights'), {
        method: 'get',
        headers: {
          Authorization: idToken,
          'Content-Type': 'application/json',
        },
      }).then((resp) => resp.json());

      if (data === undefined || data.items === undefined) {
        return;
      }

      const newInsightFiltersMap = new Map();
      data.items.forEach((item: { id: string; insights: Array<string> }) => {
        newInsightFiltersMap.set(item.id, new Set(item.insights));
      });
      setInsightFilters(newInsightFiltersMap);
    })();
  }, [aiSummary, idToken, forwardAddress]);

  useEffect(() => {
    if (!isAdmin) {
      return;
    }
    if (forwardAddress !== undefined && idToken !== null && showVip) {
      (async () => {
        const res = await fetch(forwardAddress.replace('/shadow-agent', '/vip'), {
          method: 'get',
          headers: {
            authorization: idToken,
            'Content-Type': 'application/json',
          },
        });
        if (res.ok) {
          const data = await res.json();
          setViplist(data.items);
        }
      })();
    }
  }, [forwardAddress, isAdmin, idToken]);

  const handleClick = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setChatAnchor(event.currentTarget);
  }, []);

  const openChat = Boolean(chatAnchor);

  useEffect(() => {
    if (historicals.length) {
      setHistoricals((oldHistorical) => oldHistorical.slice(1));

      setVmOnlyExtensions(historicals[0].vmOnly);
      console.log(historicals);
    }
  }, [historicals]);

  useEffect(() => {
    if (callEvents.length) {
      setCallEvents((oldCallEvents) => oldCallEvents.slice(1));
    }
  }, [callEvents]);

  useEffect(() => {
    if (queuePresenceEvents.length) {
      setQueuePresenceEvents((oldQueuePresenceEvents) => oldQueuePresenceEvents.slice(1));
    }
  }, [queuePresenceEvents]);

  useEffect(() => {
    if (callbackStates.length) {
      setCallbackStates((oldCallbackStates) => oldCallbackStates.slice(1));
    }
  }, [callbackStates]);

  // useEffect(() => {
  //   if (historicalUsers === undefined) {
  //     return;
  //   }

  //   const user =
  //     historicalUsers.find(
  //       (historicalUser: any) => historicalUser.id === rcId
  //     ) || {};

  //   if (user === undefined || user.firstName === undefined) {
  //     return;
  //   }

  //   setMessages((oldMessages) => {
  //     oldMessages.splice(0, 1, {
  //       id: 0,
  //       sender: "bot",
  //       contentType: "PlainText",
  //       content: `Hi ${user.firstName}, how can I help you?`,
  //     });

  //     return oldMessages;
  //   });
  // }, [historicalUsers, rcId]);

  // useEffect(() => {
  //   if (historicalUsers === undefined) {
  //     return;
  //   }

  //   if (organizationId === undefined) {
  //     return;
  //   }

  //   const user =
  //     historicalUsers.find(
  //       (historicalUser: any) => historicalUser.id === rcId
  //     ) || {};

  //   setBotSessionAttributes({
  //     organizationId,
  //     ...user,
  //   });
  // }, [historicalUsers, rcId, organizationId]);

  // for deviceId hard-coding
  // useEffect(() => {
  //   if (organizationId === "" && rcId === ""){
  //     setDeviceId("")
  //   }
  // }, [organizationId, rcId])

  useEffect(() => {
    if (organizationId === undefined) {
      return;
    }
    // New way
    if (!process.env.REACT_APP_LEADERBOARD_URL) {
      return;
    }
    const lbUrl = process.env.REACT_APP_LEADERBOARD_URL;
    setLeaderboardUrl(lbUrl);
    setApiUrl(lbUrl.replace('/summary', `/site/${'main-site'}`));
    setForwardAddress(lbUrl.replace('/summary', '/shadow-agent'));
    setCxAddress(lbUrl.replace('/summary', '/ringcx-data'));
    setNewCallback(true);
    setWebsocketAddress('DEPRECIATED');
  }, [organizationId]);

  useEffect(() => {
    if (timer === undefined || timer.duration === undefined) {
      return () => {};
    }

    if (timer.duration === '') {
      return () => {};
    }

    if (origin === undefined) {
      return () => {};
    }

    if (apiUrl === undefined) {
      return () => {};
    }

    const reset = async (myId: string) => {
      // tell RC
      await fetch(`${process.env.REACT_APP_API_URL}/flash`, {
        method: 'POST',
        body: JSON.stringify({
          dndStatus: 'TakeAllCalls',
          message: 'AVL:Available',
          userStatus: 'Available',
          id: myId,
          token: rcAccessToken,
        }),
        headers: {
          authorization: idToken || '',
        },
      });

      // tell SA
      setTimer(undefined);
      await fetch(apiUrl, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          event: `/restapi/v1.0/account/${organizationId}/extension/${myId}/presence`,
          body: {
            dndStatus: 'TakeAllCalls',
            presenceStatus: 'Available',
            message: 'AVL:Available',
          },
          send: true,
        }),
      });
    };

    if (parseInt(timer.duration, 10) <= 0) {
      reset(timer.id);
      return () => {};
    }

    const cb = setTimeout(() => {
      const endTimestamp =
        timer.endTimestamp ||
        new Date(new Date().setSeconds(new Date().getSeconds() + parseInt(timer.duration, 10) - 1)).toISOString();

      setTimer({
        duration: Math.round((new Date(endTimestamp).getTime() - new Date().getTime()) / 1000).toString(),
        id: timer.id,
        endTimestamp,
      });
    }, 1000);

    return () => {
      clearTimeout(cb);
    };
  }, [timer, origin, apiUrl]);

  useEffect(() => {
    if (origin === undefined) {
      return;
    }

    if (codes === undefined) {
      return;
    }

    if (rules === undefined) {
      return;
    }

    if (historicalQueues === undefined) {
      return;
    }

    if (historicalUsers.size <= 0) {
      return;
    }

    const user = historicalUsers.get(rcId);
    if (user === undefined) {
      return;
    }
    setDeviceId(user.preferredDeviceId);

    const testRule = (type: string, myRules: any[], index = 0): string => {
      if (myRules[index] === undefined) {
        return `default-${type}`;
      }

      const rule = rules[index];

      if (
        rule.categories.reduce((sum: any, re: any) => {
          if (re.category === 'Queue') {
            return (
              sum &&
              historicalQueues
                .valueSeq()
                .filter((queue) => queue.users.some((queueUser: any) => queueUser.id === user.id))
                .find((queue: any) => new RegExp(re.regularExpression).test(queue[re.field]))
            );
          }

          if (re.category === 'Extension') {
            return sum && new RegExp(re.regularExpression).test(user[re.field]);
          }

          if (re.category === 'Department') {
            return sum && new RegExp(re.regularExpression).test(user.department);
          }

          return false;
        }, true)
      ) {
        return rule[type];
      }

      return testRule(type, myRules, index + 1);
    };

    const sortedRules = rules.sort((a, b) => a.order - b.order);

    const disposition = testRule(
      'disposition',
      sortedRules.filter((rule) => rule.disposition),
    );
    const account = testRule(
      'account',
      sortedRules.filter((rule) => rule.account),
    );
    const forced = testRule(
      'forced',
      sortedRules.filter((rule) => rule.forced),
    );

    // window.parent.postMessage(
    //   JSON.stringify({
    //     event: "profile-button",
    //     display: user.display,
    //   }),
    //   origin
    // );

    window.parent.postMessage(
      JSON.stringify({
        event: 'forced-account-codes',
        codes: codes.filter((code) => code.id === forced),
      }),
      origin,
    );

    setDispositionCodes(codes.filter((code) => code.id === disposition));
    setAccountCodes(codes.filter((code) => code.id === account));
    setForcedCodes(codes.filter((code) => code.id === forced));
    setAcw(
      new Map<string, { duration: string; label: string }>(
        historicalQueues
          .valueSeq()
          .filter((queue) => queue.acw !== undefined)
          .map((queue) => [queue.id, { duration: queue.acw.duration, label: queue.acw.label }])
          .toArray() as [string, { duration: string; label: string }][],
      ),
    );
  }, [origin, codes, rules, rcId, historicalUsers, historicalQueues]);

  // useEffect(() => {
  //   if (origin === undefined) {
  //     return;
  //   }
  //   const meEX = presenceEvents.reduce((sum, stateEvent) => {
  //     if (stateEvent.id !== rcId) {
  //       return sum;
  //     }

  //     if (
  //       sum?.messageTimestamp &&
  //       stateEvent.messageTimestamp < sum.messageTimestamp
  //     ) {
  //       return sum;
  //     }

  //     return stateEvent;
  //   }, undefined as UserPresenceEvent | undefined);

  //   if (meEX) {
  //     window.parent.postMessage(
  //       JSON.stringify({
  //         event: "profile-button",
  //         display: meEX.display,
  //       }),
  //       origin
  //     );
  //   }
  // }, [presenceEvents, origin]);

  useEffect(() => {
    if (profileId === undefined || profileId === '') {
      return;
    }

    setPage('profile');
  }, [profileId]);

  useEffect(() => {
    if (vipList === undefined || origin === undefined) {
      return () => {};
    }
    function regexCheck(str: string | undefined, number: string): boolean {
      if (str === undefined) {
        return false;
      }
      const escapeRegex = (s: string): string => s.replace(/([.+^=!:${}()|\\])/g, '\\$1');

      const temp = '^'.concat(number.split('*').map(escapeRegex).join('.*'), '$');
      const r = new RegExp(temp.split('?').join('.'));

      return r.test(str);
    }

    const listener = (e: MessageEvent) => {
      const {
        data: { type, userStatus, dndStatus, message, call: { from, to, direction } = {} },
      } = e as PresenceEvent;
      if (type !== undefined) {
        if (type === 'shadow-agent-set-presence') {
          fetch(`${process.env.REACT_APP_API_URL}/flash`, {
            method: 'POST',
            body: JSON.stringify({
              dndStatus,
              message,
              userStatus,
              id: rcId,
              token: rcAccessToken,
            }),
            headers: {
              authorization: idToken || '',
            },
          });
          // window.parent.postMessage(
          //   JSON.stringify({
          //     event: "flash-message",
          //     userStatus,
          //     dndStatus,
          //     message,
          //     id: rcId,
          //   }),
          //   origin
          // );
        } else if (
          type === 'rc-call-ring-notify' ||
          type === 'rc-call-init-notify' ||
          type === 'rc-call-start-notify'
        ) {
          let vip;

          if (direction === 'Inbound') {
            vip = vipList.find(({ number }: { number: string }) => regexCheck(from, number));
          } else if (direction === 'Outbound') {
            vip = vipList.find(({ number }: { number: string }) => regexCheck(to, number));
          }
          if (vip !== undefined) {
            window.parent.postMessage(
              JSON.stringify({
                event: 'vip',
                vip: vip.name,
              }),
              origin,
            );
          }
        }
      }
    };
    window.addEventListener('message', listener);

    return () => {
      window.removeEventListener('message', listener);
    };
  }, [rcId, vipList, origin]);

  const getSummary = useCallback(
    (summaryUrl: string) => {
      try {
        if (idToken === undefined) {
          throw new Error('id token undefined');
        }
        return fetch(summaryUrl, {
          headers: {
            Authorization: idToken || '',
          },
        })
          .then((res: any) => {
            if (res.status !== 200) {
              throw new Error('bad response');
            }
            return res.json();
          })
          .then((summary: Summary) => summary);
      } catch (err) {
        console.error('error ', err);
      }
      return Promise.reject();
    },
    [idToken, newCallback],
  );

  useEffect(() => {
    setElapsedTime(local[`queue-summary-${rcId}-elapsedTime`] || 'full');
  }, [rcId]);

  useEffect(() => {
    if (rcId !== undefined && leaderboardUrl !== undefined) {
      const todayStart = new Date();
      todayStart.setHours(0, 0, 0, 0);

      const myUrl = `${leaderboardUrl}?startTime=${todayStart.toISOString()}`;

      localforage.clear();
    }
  }, [rcId, leaderboardUrl]);

  useEffect(() => {
    if (summaries.length) {
      setSummaries((oldSummaries) => oldSummaries.slice(1));
    }
  }, [summaries]);

  const updateLocal = useCallback(
    (key, value) => {
      if (origin) {
        window.parent.postMessage(
          JSON.stringify({
            key,
            value,
            event: 'localstorage',
          }),
          origin,
        );

        // this is ugly
        setLocal((oldLocal: any) => {
          const newLocal = { ...oldLocal };
          newLocal[key] = value;
          return newLocal;
        });
      }
    },
    [origin],
  );

  // close the chat each time the page is changed
  useEffect(() => {
    if (page === 'embeddable') {
      setOpen(false);
    }
    setChatAnchor(null);
  }, [page]);

  useEffect(() => {
    if (queueCallStates.length === 0) {
      return;
    }
    setHistoricalQueues((oldHistoricalQueues) => {
      if (!oldHistoricalQueues) return oldHistoricalQueues;

      // Process queueCallStates and update historicalQueues immutably
      const updatedHistoricalQueues = queueCallStates.reduce((qs, record) => {
        if (!record.queueId || record.userId !== undefined) {
          // Skip records for specific users or without a queueId
          return qs;
        }

        const queue = qs.get(record.queueId);
        if (!queue) {
          // Skip if the queue doesn't exist
          return qs;
        }

        // Create a copy of the queue to ensure immutability
        const updatedQueue = {
          ...queue,
          waiting: queue.waiting || new Set(),
          ringTimes: queue.ringTimes || new Map(),
        };

        if (updatedQueue.lastEventProcessed === undefined || updatedQueue.lastEventProcessed <= record.time) {
          if (record.state === 'RINGING') {
            updatedQueue.waiting.add(record.callId);

            const existingTime = updatedQueue.ringTimes.get(record.callId);
            if (existingTime === undefined || existingTime > record.time) {
              // Update with the earliest ring time
              updatedQueue.ringTimes.set(record.callId, record.time);
            }
          } else {
            // Remove call from waiting and ring times if it's not in RINGING state
            updatedQueue.waiting.delete(record.callId);
            updatedQueue.ringTimes.delete(record.callId);
          }

          updatedQueue.lastEventProcessed = record.time;
        }

        // Update the queue in the Immutable.Map
        return qs.set(record.queueId, updatedQueue);
      }, oldHistoricalQueues);

      return updatedHistoricalQueues;
    });
  }, [queueCallStates]);

  useEffect(() => {
    if (!presenceEvents || presenceEvents.length === 0) {
      return;
    }

    setHistoricalQueues((oldHistoricalQueues) => {
      if (!oldHistoricalQueues) return oldHistoricalQueues;

      // Update the historical queues immutably
      const updatedHistoricalQueues = presenceEvents.reduce((qs, event) => {
        // Find the queue(s) containing the user from the event
        qs.forEach((queue, queueId) => {
          const userIndex = queue.users?.findIndex((user: any) => user.id === event.id);

          if (userIndex !== undefined && userIndex >= 0) {
            const updatedUser = {
              ...queue.users[userIndex],
              acceptQueueCalls:
                event.display?.startsWith('AVL:') && event.lastDndStatus !== 'DoNotAcceptDepartmentCalls',
            };

            // Update the users array immutably
            const updatedUsers = [...queue.users];
            updatedUsers[userIndex] = updatedUser;

            // Update the queue immutably
            const updatedQueue = {
              ...queue,
              users: updatedUsers,
            };

            // Set the updated queue in the Immutable.Map
            qs.set(queueId, updatedQueue);
          }
        });

        return qs;
      }, oldHistoricalQueues);

      return updatedHistoricalQueues;
    });
  }, [presenceEvents]);

  useEffect(() => {
    if (rcId) {
      const getLeaderboardConfig = localStorage.getItem(`show-ex-leaderboards-${rcId}`) || 'true';
      setShowLeaderboards(JSON.parse(getLeaderboardConfig));
    }
  }, [rcId]);

  useEffect(() => {
    if (rcId) {
      const getElapsedDisplayConfig = localStorage.getItem(`elapsed-time-display-${rcId}`) || 'full';
      setElapsedTime(getElapsedDisplayConfig);
    }
  }, [rcId]);

  if (websocketAddress === undefined) {
    return null;
  }

  if (forwardAddress === undefined) {
    return null;
  }
  if (apiUrl === undefined) {
    return null;
  }

  const adminclick = (theId: string | undefined) => setProfileId(theId);

  return (
    <div className={mode === 'light' ? 'light' : 'dark'} style={{ position: 'relative' }}>
      {hasBrowserPhone && (
        <div style={{ display: dialer && hasBrowserPhone ? 'block' : 'none' }}>
          <DialerBox
            idToken={idToken}
            changeTab={changeTab}
            rcAccessToken={rcAccessToken}
            setDialer={setDialer}
            dialer={hasBrowserPhone}
            selectedDialer={selectedDialer}
            cxEnabled={cxEnabled}
            setSelectedDialer={setSelectedDialer}
            dialerMessage={dialerMessage}
            mode={mode as 'light' | 'dark'}
            clientId={clientId}
            redirectUri={redirectUri}
            setActiveCall={setActiveCall}
            activeCall={activeCall}
            setPage={setPage}
            ref={dialerReference}
            forcedAccountCodes={forcedCodes || []}
            hasForcedAccountCodes={hasForcedAccountCodes}
            setCodeMap={setCodeMap}
          />
        </div>
      )}
      <div style={{ display: sai && !legacyUI ? 'block' : 'none' }}>
        <SaiDraggableWrapper
          mode={mode}
          clientId={clientId}
          rcAccessToken={rcAccessToken}
          token={idToken}
          setSai={setSai}
          userUri={`${historicalUsers.get(rcId)?.uri}?access_token=${rcAccessToken}`}
          userLeaderboardApi={userLeaderboardApi}
        />
      </div>

      <div className={`loading-placeholder-bg ${mode === 'light' ? 'light' : 'dark'}`}>
        <div className="placeholder-bg-inner" />
      </div>
      {idToken && origin && email && rcId && organizationId && (
        <Websocket
          setIvrDeltas={setIvrDeltas}
          setIvrStates={setIvrStates}
          setHistoricalIvr={setHistoricalIvr}
          setCodeMap={setCodeMap}
          setHistoricalAgents={setHistoricalAgents}
          setSmsData={setSmsData}
          setCallbacks={setCallbacks}
          setDeletedVoiceMails={setDeletedVoiceMails}
          setMyCalls={setMyCalls}
          setLiveCalls={setLiveCalls}
          rcId={rcId}
          organizationId={organizationId}
          idToken={idToken}
          setHistoricalQueues={setHistoricalQueues}
          setHistoricalUsers={setHistoricalUsers}
          origin={origin}
          setTables={setTables}
          setCodes={setCodes}
          setRules={setRules}
          forwardAddress={forwardAddress}
          setOffset={setOffset}
          setHistoricals={setHistoricals}
          setQueueCallStates={setQueueCallStates}
          setCallbackStates={setCallbackStates}
          setPresenceEvents={setPresenceEvents}
          setQueuePresenceEvents={setQueuePresenceEvents}
          leaderboardUrl={leaderboardUrl}
          setLeaderboardDeltas={setLeaderboardDeltas}
          setViplist={setViplist}
          setMarkedAsCalledBack={setMarkedAsCalledBack}
          setIvrLists={setIvrLists}
          setUserStates={setUserStates}
        />
      )}
      {historicalUsers.size > 0 && idToken && origin && email && rcId && organizationId && (
        <div
          style={{
            overflow: 'auto',
            background: mode === 'light' ? 'white' : '#333',
          }}
        >
          <Navbar
            rcId={rcId}
            isAdmin={isAdmin}
            showLeaderboards={showLeaderboards}
            ivrSummary={ivrSummary}
            adminclick={adminclick}
            sai={sai}
            setSai={setSai}
            vipList={vipList}
            orgId={organizationId}
            activeCall={activeCall}
            setActiveCall={setActiveCall}
            rcAccessToken={rcAccessToken}
            uri={historicalUsers.get(rcId)?.uri || './default-user-image.ico'}
            setProfileId={setProfileId}
            dialer={dialer}
            setDialer={setDialer}
            legacyUI={legacyUI}
            mobileNav={mobileNav}
            showAvailable={showAvailable}
            showDnd={showDnd}
            showInvisible={showInvisible}
            showBusy={showBusy}
            setShowInvisible={setShowInvisible}
            setShowBusy={setShowBusy}
            setShowAvailable={setShowAvailable}
            setShowDnd={setShowDnd}
            page={page}
            setPage={setPage}
            mode={mode}
            tab={tab}
            setTab={setTab}
            setMobileNav={setMobileNav}
            setSidebar={setSidebar}
            sidebar={sidebar}
            meEx={historicalUsers.get(rcId)}
            meCx={cxAgents?.find((user) => user.rcUserId?.toString() === rcId.toString())}
            hasCx={!!cxEnabled}
            hasC2G={hasC2G}
            hasDispositionTab={hasDispositionTab}
            hasCustomerPortal={flags.customerPortal}
            browserPhone={hasBrowserPhone}
            resetDialerPosition={resetDialerPosition}
          />
          {origin && <SleepDetector origin={origin} />}
          {queueLeaderboards && (
            <div
              style={
                tab === 'queues' && page === 'hud' && showQueueLeaderboards && showLeaderboards
                  ? { paddingTop: 5 }
                  : { display: 'none', paddingTop: 5 }
              }
              className={`leaderboard${sidebar ? ' sidebar' : ''}`}
            >
              <Queues
                tabCounts={tabCounts}
                setTabCounts={setTabCounts}
                agentData={agentData}
                newCallback={newCallback}
                historicals={historicals}
                excludedQueues={excluded}
                showAvailable={showAvailable}
                showBusy={showBusy}
                showDnd={showDnd}
                showInvisible={showInvisible}
                presenceEvents={presenceEvents}
                callEvents={callEvents}
                queuePresenceEvents={queuePresenceEvents}
                mode={mode}
                summaries={summaries}
                getSummary={getSummary}
                leaderboardUrl={leaderboardUrl}
                updateLocal={updateLocal}
                local={local}
                page={page}
                hudTab={tab}
                offset={offset}
                queueCallStates={queueCallStates}
                callbackStates={callbackStates}
                deviceId={deviceId}
                rcAccessToken={rcAccessToken}
                queueCallPickUp={queueCallPickUp}
                showCherryPick={showCherryPick}
                spoiledCherryPickCalls={spoiledCherryPickCalls}
                setSpoiledCherryPickCalls={setSpoiledCherryPickCalls}
                showVip={showVip}
                vipList={vipList}
                showCallback={showCallback}
                callbacks={callbacks}
                rcId={rcId}
                selfUser={historicalUsers.get(rcId)}
                accessToken={idToken}
                forwardAddress={forwardAddress}
                origin={origin}
                organizationId={organizationId}
                markedAsCalledBack={markedAsCalledBack}
                navTab={tab}
                navPage={page}
                agentLeaderboard={agentLeaderboard}
                leaderboardDeltas={leaderboardDeltas}
                apiUrl={apiUrl}
                deletedVMs={deletedVMs}
                setActiveFilterRef={setActiveFilterRef}
              />
            </div>
          )}
          {organizationId === '3154756020' && (
            <div
              style={{
                display: tab === 'live' && page === 'hud' ? '' : 'none',
                zIndex: tab === 'live' && page === 'hud' ? 'auto' : -9999999,
                opacity: tab === 'live' && page === 'hud' ? 1 : 0,
                height: tab === 'live' && page === 'hud' ? 'calc(100vh - 105px)' : 0,
                maxHeight: tab === 'live' && page === 'hud' ? 'calc(100vh - 105px)' : 0,
              }}
            >
              <LiveDashboard
                tabCounts={tabCounts}
                mode={mode}
                accessToken={rcAccessToken}
                ivrStates={ivrStates}
                historicalUsers={historicalUsers}
                historicalQueues={historicalQueues}
                orgId={organizationId}
                queueCallStates={queueCallStates}
                // historicalIvrs={historicalIvr}
                liveQueueMetrics={liveQueueMetrics}
                leaderboardDeltas={leaderboardDeltas}
              />
            </div>
          )}
          <div
            style={
              rcId && historicalQueues && page === 'hud' && tab !== 'cx' && tab !== 'cx-queues'
                ? {}
                : { display: 'none' }
            }
          >
            <Hud
              setLiveQueueMetrics={setLiveQueueMetrics}
              cxAgents={cxAgents}
              profileId={profileId}
              doubleWidgets={doubleWidgets}
              setUserLeaderboardApi={setUserLeaderboardApi}
              ivrSummary={ivrSummary}
              historicalIvr={historicalIvr}
              ivrStates={ivrStates}
              ivrDeltas={ivrDeltas}
              fullscreen={fullscreen}
              setFullscreen={setFullscreen}
              smsData={smsData}
              idToken={idToken}
              excludedIvrs={excludedIvrs}
              setExcludedIvrs={setExcludedIvrs}
              excludedAirs={excludedAirs}
              setExcludedAirs={setExcludedAirs}
              rcAccessToken={rcAccessToken}
              setQueueCallStates={setQueueCallStates}
              historicals={historicals}
              userState={userStates}
              callEvents={callEvents}
              presenceEvents={presenceEvents}
              queuePresenceEvents={queuePresenceEvents}
              isVisible={!!(rcId && historicalQueues && page === 'hud')}
              summaries={summaries}
              setDialer={setBrowserPhone}
              historicalUsers={historicalUsers}
              historicalQueues={historicalQueues}
              excluded={excluded}
              setExcluded={setExcluded}
              excludedUsers={excludedUsers}
              setExcludedUsers={setExcludedUsers}
              id={rcId || ''}
              origin={origin}
              mode={mode}
              sidebar={sidebar}
              showAvailable={showAvailable}
              setShowAvailable={setShowAvailable}
              showBusy={showBusy}
              setShowBusy={setShowBusy}
              showDnd={showDnd}
              setShowDnd={setShowDnd}
              showInvisible={showInvisible}
              setShowInvisible={setShowInvisible}
              isAdmin={isAdmin}
              tab={tab}
              changeTab={changeTab}
              setProfileId={setProfileId}
              showLeaderboards={showLeaderboards}
              local={local}
              rcId={rcId}
              updateLocal={updateLocal}
              elapsedTime={elapsedTime}
              hasPresenceTimer={hasPresenceTimer}
              queueCallStates={queueCallStates}
              offset={offset}
              leaderboards={leaderboards}
              leaderboardDeltas={leaderboardDeltas}
              acw={acw}
              forwardAddress={forwardAddress}
              organizationId={organizationId}
              setTimer={setTimer}
              page={page}
              showHandRaise={showHandRaise}
              supervise={supervise}
              vipList={vipList}
              navPage={page}
              userStates={userStates}
              hasRingCx={!!cxEnabled}
              apiUrl={apiUrl}
              forceAvailable={forceAvailable}
              activeFilterRef={activeFilterRef}
              legacyUI={legacyUI}
              queueCompactView={queueCompactView}
              setQueueCompactView={setQueueCompactView}
            />
          </div>
          {idToken && cxEnabled && cxAddress && (
            <div style={(tab === 'cx' || tab === 'cx-queues') && page === 'hud' ? {} : { display: 'none' }}>
              <CxDashboard
                isAdmin={isAdmin}
                organizationId={organizationId}
                apiUrl={apiUrl}
                cxAgents={cxAgents}
                setCxCallLog={setCxCallLog}
                cxCallLog={cxCallLog}
                vipList={vipList}
                setCxAgents={setCxAgents}
                cxAddress={cxAddress}
                //   cxToken={idToken}
                idToken={idToken}
                setHistoricalUsers={setHistoricalUsers}
                forwardAddress={forwardAddress}
                mode={mode}
                sidebar={sidebar}
                historicalUsers={historicalUsers}
                rcId={rcId}
                elapsedTime={elapsedTime}
                tab={tab}
                local={local}
                updateLocal={updateLocal}
                fullscreen={fullscreen}
                setFullscreen={setFullscreen}
                offset={offset}
                id={rcId}
                setCxMessages={setCxMessages}
                cxStateFilters={cxStateFilters}
                origin={origin}
                setProfileId={setProfileId}
                setPage={setPage}
                adminclick={adminclick}
                presenceEvents={presenceEvents}
                setActiveFilterRef={setActiveFilterRef}
                activeFilterRef={activeFilterRef}
                page={page}
                showCXLeaderboards={showCXLeaderboards}
              />
            </div>
          )}
          {rcId && page === 'settings' && (
            <Settings
              setChangeTab={setChangeTab}
              orgId={organizationId}
              idToken={idToken}
              id={rcId}
              origin={origin}
              mode={mode}
              rcId={rcId}
              changeTab={changeTab}
              lastCode={lastCode}
              showLeaderboards={showLeaderboards}
              elapsedTime={elapsedTime}
              setElapsedTime={setElapsedTime}
              hasPresenceTimer={hasPresenceTimer}
              hasInvisibleCallControl={hasInvisibleCallControl}
              forwardAddress={forwardAddress}
              showCherryPick={showCherryPick}
              deviceId={deviceId}
              rcAccessToken={rcAccessToken}
              setDeviceId={setDeviceId}
              setShowCherryPick={setShowCherryPick}
              queueCallPickUp={queueCallPickUp}
              updateLocal={updateLocal}
              setShowCXLeaderboards={setShowCXLeaderboards}
              showCXLeaderboards={showCXLeaderboards}
              cxEnabled={!!cxEnabled}
              setShowLeaderboards={setShowLeaderboards}
              setMode={setMode}
              legacyUI={legacyUI}
              setLegacyUI={setLegacyUI}
            />
          )}
          {rcId && rules && historicalQueues && page === 'profile' && (
            <Profile
              user={historicalUsers.get(profileId || rcId)}
              hasInvisibleCallControl={hasInvisibleCallControl && (!profileId || profileId === rcId)}
              legacyUI={legacyUI}
              hasCX={!!cxEnabled}
              rcAccessToken={rcAccessToken}
              historicalQueues={historicalQueues}
              origin={origin}
              organizationId={organizationId}
              rcId={profileId || rcId}
              tables={tables}
              timer={timer}
              setTimer={setTimer}
              mode={mode}
              rules={rules.sort((a, b) => a.order - b.order)}
              forwardAddress={forwardAddress}
              idToken={idToken}
              presenceQueue={presenceQueue}
              hasDispositionTab={hasDispositionTab}
              isAdmin={isAdmin}
              showHandRaise={showHandRaise}
              myId={rcId}
              apiUrl={apiUrl}
              cxAgents={cxAgents}
              lateTimer={lateTimer}
              setLateTimer={setLateTimer}
              elapsedTime={elapsedTime}
            />
          )}
          {/* {hasDispositionTab && !newDisposition && (
              <div
                style={
                  rcId && idToken && page === "disposition"
                    ? {}
                    : { display: "none" }
                }
              >
                <Disposition
                  rcAccessToken={rcAccessToken}
                  myCalls={myCalls}
                  isVisible={!!(rcId && idToken && page === "disposition")}
                  id={rcId}
                  myEvents={myEvents}
                  callEvents={callEvents}
                  mode={mode}
                  origin={origin}
                  dispositionCodes={dispositionCodes}
                  accountCodes={accountCodes}
                  forcedCodes={forcedCodes}
                  address={apiUrl}
                  organizationId={organizationId}
                  hasDispositionCodes={hasDispositionCodes}
                  hasAccountCodes={hasAccountCodes}
                  hasForcedAccountCodes={hasForcedAccountCodes}
                  noEncoding={noEncoding}
                  idToken={idToken}
                  offset={offset}
                  updateLocal={updateLocal}
                  local={local}
                  vip={vipList}
                  page={page}
                />
              </div>
            )} */}
          {dispositionCodes && flags.dispositionTab && accountCodes && forcedCodes && (
            <div
              style={
                rcId && idToken && page === 'disposition'
                  ? { background: mode === 'light' ? 'white' : '#333' }
                  : { display: 'none' }
              }
            >
              <NewDisposition
                setCodeMap={setCodeMap}
                codeMap={codeMap}
                dispositionCodes={dispositionCodes}
                accountCodes={accountCodes}
                forcedCodes={forcedCodes}
                idToken={idToken}
                accessToken={rcAccessToken}
                vip={vipList}
                cxCallLog={cxCallLog}
                noEncoding={!!noEncoding}
                organizationId={organizationId}
                rcId={rcId}
                origin={origin}
                mode={mode}
                hasCx={!!cxEnabled}
                hasDispositionCodes={!!flags.dispositionCodes}
                hasAccountCodes={!!flags.accountCodes}
                hasForcedCodes={hasForcedAccountCodes}
              />
            </div>
          )}

          {codes && tables && historicalQueues && page === 'portal' && websocketAddress && isAdmin && (
            <div style={{}}>
              <PortalFrame
                lightMode={mode === 'light'}
                isSuperAdmin={superAdmin}
                hasAccountCodes={hasAccountCodes}
                hasDispositionCodes={hasDispositionCodes}
                showVip={showVip}
              >
                <TabComponent tab="Codes">
                  <Codes
                    lightMode={mode === 'light'}
                    dispositionCodes={dispositionCodes || []}
                    accountCodes={accountCodes || []}
                    forcedCodes={forcedCodes || []}
                    orgId={organizationId}
                    token={idToken}
                    hasForcedAccountCodes={hasForcedAccountCodes}
                    hasDispositionCodes={hasDispositionCodes}
                    hasAccountCodes={hasAccountCodes}
                  />
                </TabComponent>

                <TabComponent tab="Presences">
                  <Presences
                    lightMode={mode === 'light'}
                    presenceTables={tables}
                    token={idToken}
                    historicalQueues={historicalQueues}
                    orgId={organizationId}
                  />
                </TabComponent>

                <TabComponent tab="Globals">
                  <Globals lightMode={mode === 'light'} token={idToken} />
                </TabComponent>

                <TabComponent tab="Vip">
                  <Vip
                    lightMode={mode === 'light'}
                    token={idToken}
                    vipList={vipList}
                    setVipList={setViplist}
                    orgId={organizationId}
                  />
                </TabComponent>

                <TabComponent tab="Users">
                  <Users lightMode={mode === 'light'} token={idToken} superAdmin={superAdmin} orgId={organizationId} />
                </TabComponent>

                <TabComponent tab="Queues">
                  <QueuesPortal
                    lightMode={mode === 'light'}
                    token={idToken}
                    historicalQueues={historicalQueues}
                    setHistoricalQueues={setHistoricalQueues}
                    presenceTables={tables}
                    vmOnlyExtensions={vmOnlyExtensions}
                    ivrList={ivrLists}
                    showCallback={showCallback}
                  />
                </TabComponent>
              </PortalFrame>
            </div>
          )}
          {/* {lexBot && page !== "embeddable" && (
            <div>
              <IconButton
                style={{
                  position: "fixed",
                  bottom: 40,
                  right: 50,
                  color: "white",
                }}
                className={classes.button}
                onClick={handleClick}
                size="medium"
              >
                <QuestionAnswer />
              </IconButton>
              <Popover
                id="lex-bot-chat"
                open={openChat}
                anchorEl={chatAnchor}
                // onClose={handleClose}
                anchorOrigin={{
                  vertical: "center",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                PaperProps={{
                  style: { width: "55vh", backgroundColor: "transparent" },
                }}
              >
                <Chat
                  messages={messages}
                  setMessages={setMessages}
                  botSessionAttributes={botSessionAttributes}
                  setBotSessionAttributes={setBotSessionAttributes}
                  idToken={idToken}
                  sessionId={sessionId}
                  setChatAnchor={setChatAnchor}
                  mode={mode}
                />
              </Popover>
            </div>
          )} */}
          {page === 'c2g' && hasC2G && idToken && (
            <C2GReport
              token={idToken}
              mode={mode}
              organizationId={organizationId}
              cxToken={null}
              cxMessages={cxMessages}
              setCxMessages={setCxMessages}
              cxEnabled={!!cxEnabled}
              leaderboardUrl={leaderboardUrl}
              historicalUsers={historicalUsers}
              historicalQueues={historicalQueues}
              cxAgents={cxAgents}
              legacyUI={legacyUI}
              realTimeUserStates={realTimeUserStates}
              setRealTimeUserStates={setRealTimeUserStates}
            />
          )}
          {/* <div style={{left: 0, bottom: 0, position: 'absolute'}}> */}
          {/* </div> */}
          {/* {(dialer || organizationId === "3154756020") &&
            page !== "embeddable" && (
              <DraggablePopper
                bounds={{
                  left: 0,
                  top: 0,
                  right: window.innerWidth,
                  bottom: window.innerHeight,
                }}
                dialer={dialer}
                mode={mode}
                open={open}
                setOpen={setOpen}
                rcId={rcId}
                origin={origin}
                // callEvents={callEvents}
                // vip={vipList}
                dialerStatus={dialerStatus}
              />
            )} */}
        </div>
      )}
    </div>
  );
}

export default App;
